import {Route, Routes} from 'react-router-dom'
import {Resellers} from 'modules/reseller/Resellers'
import {Reseller} from 'modules/reseller/Reseller'
import {Businesses} from 'modules/business/Businesses'
import {Business} from 'modules/business/Business'
import {Device} from 'modules/device/Device'
import {DeviceTypes} from 'utility/utility'
import { Group } from 'modules/group/Group'

export const ResellerRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Resellers />} />
      <Route path="/create" element={<Reseller />} />
      <Route path="/:reseller" element={<Reseller />} />
      <Route path="/:reseller/business" element={<Businesses />} />
      <Route path="/:reseller/business/:business" element={<Business />} />

      <Route path="/:reseller/business/:business/group/:group" element={<Group />} />

      <Route
        path={`/:reseller/business/:business/${DeviceTypes.OFFICE}/create`}
        element={<Device office />}
      />
      <Route
        path={`/:reseller/business/:business/${DeviceTypes.OFFICE}/update/:device`}
        element={<Device office update />}
      />
      <Route path={`/:reseller/business/:business/${DeviceTypes.REMOTE}/create/:user`} element={<Device />} />
      <Route
        path={`/:reseller/business/:business/${DeviceTypes.REMOTE}/update/:user/:device`}
        element={<Device update />}
      />
    </Routes>
  )
}
